"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const lucide_react_1 = require("lucide-react");
require("./TitleBar.css");
const logoIcon = require('../../assets/icon.png');
const getIpcRenderer = () => {
    if (typeof window !== 'undefined' && window.require) {
        try {
            return window.require('electron').ipcRenderer;
        }
        catch (e) {
            return null;
        }
    }
    return null;
};
const TitleBar = () => {
    const ipcRenderer = getIpcRenderer();
    if (!ipcRenderer) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "titlebar", children: (0, jsx_runtime_1.jsxs)("div", { className: "titlebar-drag", children: [(0, jsx_runtime_1.jsx)("div", { className: "titlebar-logo", children: (0, jsx_runtime_1.jsx)("img", { src: logoIcon, alt: "Meci", className: "m-logo-img" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "titlebar-brand", children: [(0, jsx_runtime_1.jsx)("span", { className: "brand-name", children: "MECI" }), (0, jsx_runtime_1.jsx)("span", { className: "brand-status", children: "WEB" })] })] }) }));
    }
    const handleMinimize = () => {
        ipcRenderer.send('window-minimize');
    };
    const handleMaximize = () => {
        ipcRenderer.send('window-maximize');
    };
    const handleClose = () => {
        ipcRenderer.send('window-close');
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "titlebar", children: [(0, jsx_runtime_1.jsxs)("div", { className: "titlebar-drag", children: [(0, jsx_runtime_1.jsx)("div", { className: "titlebar-logo", children: (0, jsx_runtime_1.jsx)("img", { src: logoIcon, alt: "Meci", className: "m-logo-img" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "titlebar-brand", children: [(0, jsx_runtime_1.jsx)("span", { className: "brand-name", children: "MECI" }), (0, jsx_runtime_1.jsx)("span", { className: "brand-status", children: "BETA" })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "titlebar-controls", children: [(0, jsx_runtime_1.jsx)("button", { className: "control-btn minimize", onClick: handleMinimize, title: "K\u00FC\u00E7\u00FClt", children: (0, jsx_runtime_1.jsx)(lucide_react_1.Minus, { size: 14 }) }), (0, jsx_runtime_1.jsx)("button", { className: "control-btn maximize", onClick: handleMaximize, title: "Tam Ekran", children: (0, jsx_runtime_1.jsx)(lucide_react_1.Square, { size: 12 }) }), (0, jsx_runtime_1.jsx)("button", { className: "control-btn close", onClick: handleClose, title: "Kapat", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 14 }) })] })] }));
};
exports.TitleBar = TitleBar;
